(()=>{
  const context=document.querySelector('[data-imperial-discovery-context]');
  if(!context)return;
  const norm=s=>(s||'').replace(/\s+/g,' ').trim().toLowerCase();
  function metalClass(text){
    const t=norm(text);
    if(t.includes('three')||t.includes('3 colour')||t.includes('3 color')||t.includes('tri-colour')||t.includes('tricolour'))return'three-tone';
    if(t.includes('two')||t.includes('2 colour')||t.includes('2 color')||t.includes('bi-colour')||t.includes('bicolour'))return'two-tone';
    if(t.includes('rose'))return'rose';
    if(t.includes('white gold'))return'white';
    if(t.includes('yellow gold')||t==='gold'||t.match(/(^| )(?:9|14|18|22|24)(?:ct|k) gold/))return'yellow';
    if(t.includes('platinum'))return'platinum';
    if(t.includes('palladium'))return'palladium';
    if(t.includes('silver')||t.includes('sterling'))return'silver';
    if(t.includes('gold'))return'yellow';
    return'other';
  }
  function swatch(text){
    const el=document.createElement('span');
    el.className='imperial-metal-swatch imperial-metal-swatch--'+metalClass(text);
    el.setAttribute('aria-hidden','true');
    return el;
  }
  function decorateNative(root=document){
    root.querySelectorAll('details[data-imperial-facet-kind="metal"]').forEach(details=>{
      details.querySelectorAll('label.facets__label,label.facet-checkbox,.mobile-facets__label').forEach(label=>{
        if(label.querySelector('.imperial-metal-swatch'))return;
        const text=label.textContent||'';
        const target=label.querySelector('.facet-checkbox__text-label,.mobile-facets__label-text')||[...label.querySelectorAll('span')].find(x=>norm(x.textContent).length>0);
        const icon=swatch(text);
        if(target&&target.parentNode===label)label.insertBefore(icon,target);
        else label.appendChild(icon);
      });
    });
  }
  function decorateFallback(root=document){
    root.querySelectorAll('.imperial-fallback-facet').forEach(block=>{
      const summary=block.querySelector(':scope>summary');
      if(!summary||!norm(summary.textContent).includes('metal'))return;
      block.querySelectorAll('.imperial-fallback-facet__option').forEach(option=>{
        if(option.querySelector('.imperial-metal-swatch'))return;
        const text=option.textContent||'';
        const label=[...option.querySelectorAll('span')].find(x=>!x.classList.contains('imperial-option-icon')&&norm(x.textContent).length>0);
        const icon=swatch(text);
        if(label)option.insertBefore(icon,label);else option.appendChild(icon);
      });
    });
  }
  function run(){decorateNative();decorateFallback();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  let queued=false;new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;run();});}).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',run);
})();